import { getCurrentUser } from 'aws-amplify/auth';
import { api } from '../apiClient';

const getRoleNames = async (userId) => {
  try {
    const roleLinks = await api.get('/user-roles', { userId });
    if (!roleLinks?.length) return [];
    const roleIds = roleLinks.map((r) => r.role_id).filter(Boolean);
    if (!roleIds.length) return [];
    const allRoles = await api.get('/roles');
    return (allRoles ?? [])
      .filter((r) => roleIds.includes(r.id))
      .map((r) => r.name);
  } catch (e) {
    console.error('ロール情報の取得に失敗しました', e);
    return [];
  }
};

/**
 * ユーザーが問題を編集する権限を持っているかをDB上のロールから判定する
 * @param {object} [user] - 省略時は Cognito から取得するユーザーオブジェクト
 * @returns {Promise<boolean>} 編集権限がある場合は true、ない場合は false
 */
export const canEditQuestions = async (user) => {
  let targetUser = user;

  if (!targetUser) {
    try {
      targetUser = await getCurrentUser();
    } catch (e) {
      console.error('ユーザー情報の取得に失敗しました', e);
      return false;
    }
  }

  // Cognito ユーザーの ID は userId プロパティに格納される
  const userId = targetUser?.userId ?? targetUser?.id;
  if (!userId) return false;

  const roleNames = await getRoleNames(userId);
  return roleNames.some((name) => name === 'editor' || name === 'admin');
};

/**
 * ユーザーが管理者権限を持っているかをDB上のロールから判定する
 * @param {object} [user] - 省略時は Cognito から取得するユーザーオブジェクト
 * @returns {Promise<boolean>} 管理者権限がある場合は true、ない場合は false
 */
export const isAdmin = async (user) => {
  let targetUser = user;

  if (!targetUser) {
    try {
      targetUser = await getCurrentUser();
    } catch (e) {
      console.error('ユーザー情報の取得に失敗しました', e);
      return false;
    }
  }

  // Cognito ユーザーの ID は userId プロパティに格納される
  const userId = targetUser?.userId ?? targetUser?.id;
  if (!userId) return false;

  const roleNames = await getRoleNames(userId);
  return roleNames.includes('admin');
};
